import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // Get all buckets
    getBuckets: () => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/s3/buckets`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get bucket metrics
    getBucketMetrics: (bucket, startDate, endDate) => {
        const credentials = getCredentialsFromLocalStorage();

        const timeRange = [startDate];
        if (endDate) {
            timeRange.push(endDate);
        }

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/utapi/buckets`)
                .set('x-access-token', credentials)
                .send({
                    buckets: [bucket],
                    timeRange,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get bucket history
    getBucketHistory: (bucket, interval, startDate, endDate) => {
        const credentials = getCredentialsFromLocalStorage();

        const timeRange = [startDate];
        if (endDate) {
            timeRange.push(endDate);
        }

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/utapi` +
                `/history/${interval}/buckets`)
                .set('x-access-token', credentials)
                .send({
                    buckets: [bucket],
                    timeRange,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get multiple buckets history
    getMultipleBucketsHistory: (interval, startDate, endDate) => {
        const credentials = getCredentialsFromLocalStorage();

        const timeRange = [startDate];
        if (endDate) {
            timeRange.push(endDate);
        }

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/utapi` +
                `/history/buckets/all/${interval}`)
                .set('x-access-token', credentials)
                .send({
                    timeRange,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },


};



/** WEBPACK FOOTER **
 ** ./src/utils/BucketsAPI.js
 **/